import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AssignedVehicleDetails, AssignedVehiclesPaginatedRequest } from "../models/vehicle-assignment.model";
import { Pagination, Response } from '../../../_shared/models';
import { firstValueFrom, Subject, takeUntil } from "rxjs";
import { environment } from "../../../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class VehicleAssignmentListService {

  constructor(private http: HttpClient) { }

  public getDriverVehicles(request: AssignedVehiclesPaginatedRequest, cancellation: Subject<void>): Promise<Response<Pagination<AssignedVehicleDetails[]>>> {
    return firstValueFrom(this.http.post(`${environment.apiEndpoint}/vehicleassignment/search-assigned-vehicle-details`, request).pipe(takeUntil(cancellation)));
  }
}